
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("70LTe", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $da99c994e33d3600$export$6654a9a4dc3a2802 = ()=>{
    return (0, $42omo.useCallback)((payload, type)=>{
        window.parent.postMessage({
            type: type,
            payload: payload
        }, '*');
    }, []);
};
module.exports["useEmbeddedConfluenceEventMarkers"] = $da99c994e33d3600$export$6654a9a4dc3a2802;

});

parcelRegister("dpqzw", function(module, exports) {
const $e10f62297c04a73f$export$51c8f3f20bd49804 = 'fabric-editor-popup-scroll-parent';
const $e10f62297c04a73f$export$547bf96576574b25 = '.ProseMirror > *';
const $e10f62297c04a73f$export$f76b40820c13783a = '.ak-renderer-document';
const $e10f62297c04a73f$export$7718f42d39a9217b = 'content';
module.exports["EDITOR_PARENT_CLASS"] = $e10f62297c04a73f$export$51c8f3f20bd49804;
module.exports["EDITOR_CHILDREN_SELECTOR"] = $e10f62297c04a73f$export$547bf96576574b25;
module.exports["RENDERED_CONTENT_SELECTOR"] = $e10f62297c04a73f$export$f76b40820c13783a;
module.exports["FABRIC_PAGE_CONTENT_ID"] = $e10f62297c04a73f$export$7718f42d39a9217b;

});

parcelRegister("gkIgp", function(module, exports) {
var $44e99c386783fe05$export$ea1a2a449eaeaa2d = /*#__PURE__*/ function(CollabServiceProperty) {
    CollabServiceProperty["NCS"] = "ncs";
    CollabServiceProperty["SYNCHRONY"] = "synchrony";
    return CollabServiceProperty;
}({});
module.exports["CollabServiceProperty"] = $44e99c386783fe05$export$ea1a2a449eaeaa2d;

});

parcelRegister("iAOfI", function(module, exports) {

var $4YBSq = parcelRequire("4YBSq");


var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $jMyy4 = parcelRequire("jMyy4");


var $9hlns = parcelRequire("9hlns");


var $1iSzD = parcelRequire("1iSzD");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $9wGTI = parcelRequire("9wGTI");


var $gkIgp = parcelRequire("gkIgp");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $7aRa9 = parcelRequire("7aRa9");


var $3u7PM = parcelRequire("3u7PM");


var $c4cfx = parcelRequire("c4cfx");


var $7mHcA = parcelRequire("7mHcA");

const $25b07369982b4436$var$EditContentButtonQuery = (0, $4YBSq.default);
const $25b07369982b4436$var$EditContentButtonInner = (0, $7aRa9.withFlags)(({ flags: flags, contentId: contentId, isCompanyHubButton: isCompanyHubButton, ...passThroughProps })=>{
    const { epMigrationOnLoad: epMigrationOnLoad, epMigrationOnClick: epMigrationOnClick } = (0, $7mHcA.useEmbeddedMigrationQuery)(contentId, true);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($25b07369982b4436$var$EditContentButtonQuery, {
        variables: {
            contentId: contentId
        },
        // cache-and-network is required to ensure that the edit button is rendered immediately after page publish
        fetchPolicy: 'cache-and-network'
    });
    const { data: epMigrationOnLoadData, loading: epMigrationOnLoadLoading, error: epMigrationOnLoadError } = epMigrationOnLoad;
    const { migrateEPData: migrateEPData, data: epMigrationOnClickData, loading: epMigrationOnClickLoading, error: epMigrationOnClickError } = epMigrationOnClick;
    const { showNoEditAccessFlag: showNoEditAccessFlag } = (0, $3u7PM.useNoEditAccessFlag)(flags);
    let renderedEditContentButton;
    if (error) renderedEditContentButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    else if (!data && loading || !epMigrationOnLoadData && epMigrationOnLoadLoading || !epMigrationOnClickData && epMigrationOnClickLoading) renderedEditContentButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        interactionName: (0, $9wGTI.fg)('ufo-manual-experimental-holds-confluence') ? 'edit-content-button' : undefined,
        size: "small"
    });
    else {
        const contentNode = data?.content?.nodes?.[0];
        const operations = contentNode?.operations ?? [];
        const contentType = contentNode?.type ?? undefined;
        const canEdit = operations.filter((operationCheckResult)=>operationCheckResult?.operation === 'update' && operationCheckResult?.targetType === contentType).length > 0;
        if (!canEdit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            accelerator: (0, $gnkil.EDIT_SHORTCUT),
            listener: showNoEditAccessFlag
        });
        const spaceKey = data?.content?.nodes?.[0]?.space?.key ?? undefined;
        const metadataFrontend = data?.content?.nodes?.[0]?.metadata?.frontend;
        const isFabricSupported = metadataFrontend?.fabricEditorSupported ?? false;
        const isNCSContent = metadataFrontend?.collabService === (0, $gkIgp.CollabServiceProperty).NCS;
        // 'edit-embed' route (embedded editor) should only be used inside parent product and when page is ncs
        const isEmbeddedContent = ((0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() && isNCSContent) ?? false;
        const embeddedMigrationError = epMigrationOnLoadError || epMigrationOnClickError;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, embeddedMigrationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: embeddedMigrationError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4cfx.EditContentButtonComponent), {
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            isCompanyHubButton: isCompanyHubButton,
            isFabricSupported: isFabricSupported,
            isEmbeddedContent: isEmbeddedContent,
            migrateEPData: !isNCSContent ? migrateEPData : undefined,
            ...passThroughProps
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        id: contentId,
        name: (0, $irVI7.VIEW_PAGE_EDIT_BUTTON_EXPERIENCE)
    }), renderedEditContentButton);
});
const $25b07369982b4436$export$3df6d768aebb677f = /*#__PURE__*/ (0, $42omo.memo)((0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($25b07369982b4436$var$EditContentButtonInner));
$25b07369982b4436$export$3df6d768aebb677f.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    isCompanyHubButton: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onRender: (0, $c4cfx.EditContentButtonComponent).propTypes?.onRender
};
module.exports["EditContentButton"] = $25b07369982b4436$export$3df6d768aebb677f;

});

parcelRegister("c4cfx", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $jTxSS = parcelRequire("jTxSS");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");


var $4KS7f = parcelRequire("4KS7f");


var $1Zr9M = parcelRequire("1Zr9M");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $9hlns = parcelRequire("9hlns");


var $3gadb = parcelRequire("3gadb");


var $4icDV = parcelRequire("4icDV");

var $70LTe = parcelRequire("70LTe");


var $gzdsP = parcelRequire("gzdsP");


var $iFjdQ = parcelRequire("iFjdQ");


var $5q601 = parcelRequire("5q601");


var $74Lca = parcelRequire("74Lca");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $emYzJ = parcelRequire("emYzJ");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $39rFu = parcelRequire("39rFu");


var $7NoF3 = parcelRequire("7NoF3");


var $4ri4I = parcelRequire("4ri4I");


var $1NBp8 = parcelRequire("1NBp8");


var $56QzY = parcelRequire("56QzY");


var $7zgzO = parcelRequire("7zgzO");


var $dHSeC = parcelRequire("dHSeC");


var $4o1RV = parcelRequire("4o1RV");


var $de2j9 = parcelRequire("de2j9");


var $hl1Kw = parcelRequire("hl1Kw");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $lqy4C = parcelRequire("lqy4C");


var $sD2Tz = parcelRequire("sD2Tz");


var $ca2z9 = parcelRequire("ca2z9");

const $a4b894acf4b5251f$var$StyledButton = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $4KS7f.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_701w1ul9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $a4b894acf4b5251f$var$i18n = (0, $cgtv4.defineMessages)({
    editLabel: {
        id: "edit-button.edit.label",
        defaultMessage: "Edit this content"
    },
    editEmbedLabel: {
        id: "edit-button.edit.embed.label",
        defaultMessage: "Edit this embed"
    },
    editText: {
        id: "edit-button.edit.text",
        defaultMessage: "Edit"
    }
});
const $a4b894acf4b5251f$var$noop = ()=>null;
const $a4b894acf4b5251f$var$EditContentButtonComponentInner = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(113);
    const { contentId: contentId, contentType: contentType, intl: intl, isEmbeddedContent: t1, isFabricSupported: isFabricSupported, onRender: t2, spaceKey: spaceKey, migrateEPData: migrateEPData, isCompanyHubButton: t3 } = t0;
    const isEmbeddedContent = t1 === undefined ? false : t1;
    const onRender = t2 === undefined ? $a4b894acf4b5251f$var$noop : t2;
    const isCompanyHubButton = t3 === undefined ? false : t3;
    const editButtonRef = (0, $42omo.useRef)(null);
    const [localEditSource, setLocalEditSource] = (0, $42omo.useState)("");
    const [isPopupVisible, setIsPopupVisible] = (0, $42omo.useState)(false);
    const { loadEditor: loadEditor } = (0, $39rFu.useEditPageLoadingActions)();
    const { setEditSource: setEditSource } = (0, $4ri4I.useEditSourceActions)();
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [t4] = (0, $hl1Kw.useSearchSessionId)();
    const { searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics } = t4;
    const { match: match } = routesContext;
    const { routePolicy: routePolicy } = (0, $4o1RV.useNavigationPolicy)();
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            source: "page-tree-quick-action-edit"
        };
        $[0] = t5;
    } else t5 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t5);
    let t6;
    if ($[1] !== contentId || $[2] !== isFabricSupported) {
        t6 = {
            contentId: contentId,
            isFabricSupported: isFabricSupported
        };
        $[1] = contentId;
        $[2] = isFabricSupported;
        $[3] = t6;
    } else t6 = $[3];
    const { fabricEditorEligibility: fabricEditorEligibility, isFabricEligibilityLoading: isFabricEligibilityLoading } = (0, $ca2z9.useFabricEligibilityMigrationQuery)(t6);
    let t7;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {
            shortcut: (0, $gnkil.EDIT_SHORTCUT)
        };
        $[4] = t7;
    } else t7 = $[4];
    const editShortcutStrings = (0, $4tOXV.useShortcutStrings)(t7);
    const currentRouteName = match?.name;
    const isBlogpost = contentType === "blogpost";
    const t8 = isBlogpost ? "blog" : "pages";
    let t9;
    if ($[5] !== contentId || $[6] !== spaceKey || $[7] !== t8) {
        t9 = {
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: t8
        };
        $[5] = contentId;
        $[6] = spaceKey;
        $[7] = t8;
        $[8] = t9;
    } else t9 = $[8];
    const linkParams = t9;
    const dataTestId = isFabricSupported ? "fabric-edit-button" : undefined;
    const sendMetrics = (0, $70LTe.useEmbeddedConfluenceEventMarkers)();
    let routeType;
    if ($[9] !== isBlogpost || $[10] !== isCompanyHubButton || $[11] !== isEmbeddedContent || $[12] !== isFabricSupported) {
        if (isEmbeddedContent && !isBlogpost) routeType = (0, $1NBp8.EDIT_PAGE_EMBED);
        else {
            if (isCompanyHubButton) routeType = (0, $1NBp8.COMPANY_HUB_EDIT);
            else if (isFabricSupported) routeType = isBlogpost ? (0, $1NBp8.EDIT_BLOG_V2) : (0, $1NBp8.EDIT_PAGE_V2);
            else routeType = isBlogpost ? (0, $1NBp8.EDIT_BLOG) : (0, $1NBp8.EDIT_PAGE);
        }
        $[9] = isBlogpost;
        $[10] = isCompanyHubButton;
        $[11] = isEmbeddedContent;
        $[12] = isFabricSupported;
        $[13] = routeType;
    } else routeType = $[13];
    let t10;
    let t11;
    if ($[14] !== currentRouteName || $[15] !== isBlogpost || $[16] !== setEditSource) {
        t10 = ()=>{
            let entryPoint = (0, $7NoF3.PAGE_EDIT_BUTTON_CLICK);
            if (isBlogpost) entryPoint = (0, $7NoF3.BLOG_EDIT_BUTTON_CLICK);
            const isSpaceOverview = currentRouteName === (0, $1NBp8.SPACE_OVERVIEW).name;
            if (isSpaceOverview) entryPoint = (0, $7NoF3.SPACE_EDIT_BUTTON_CLICK);
            setEditSource(entryPoint);
            setLocalEditSource(entryPoint);
        };
        t11 = [
            isBlogpost,
            setEditSource,
            currentRouteName,
            setLocalEditSource
        ];
        $[14] = currentRouteName;
        $[15] = isBlogpost;
        $[16] = setEditSource;
        $[17] = t10;
        $[18] = t11;
    } else {
        t10 = $[17];
        t11 = $[18];
    }
    (0, $42omo.useEffect)(t10, t11);
    let t12;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = ()=>editButtonRef && (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(editButtonRef.current)?.click();
        $[19] = t12;
    } else t12 = $[19];
    const clickEditPencilButton = t12;
    let t13;
    if ($[20] !== currentRouteName || $[21] !== isBlogpost || $[22] !== setEditSource) {
        t13 = (isClick)=>{
            if (!isClick) {
                let entryPoint_0 = (0, $7NoF3.PAGE_EDIT_SHORTCUT_E);
                if (isBlogpost) entryPoint_0 = (0, $7NoF3.BLOG_EDIT_SHORTCUT_E);
                const isSpaceOverview_0 = currentRouteName === (0, $1NBp8.SPACE_OVERVIEW).name;
                if (isSpaceOverview_0) entryPoint_0 = (0, $7NoF3.SPACE_EDIT_SHORTCUT_E);
                setEditSource(entryPoint_0);
                setLocalEditSource(entryPoint_0);
            }
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_INTENT_EDIT_FMP_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_INTENT_EDIT_TTI_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.VIEW_EDIT_BUTTON_CLICKED_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_ROUTE_CHANGE_ACTION));
        };
        $[20] = currentRouteName;
        $[21] = isBlogpost;
        $[22] = setEditSource;
        $[23] = t13;
    } else t13 = $[23];
    const measureEditButtonClickConversion = t13;
    let t14;
    if ($[24] !== contentId || $[25] !== contentType || $[26] !== currentRouteName || $[27] !== isBlogpost || $[28] !== isEmbeddedContent || $[29] !== isFabricSupported || $[30] !== linkParams || $[31] !== loadEditor || $[32] !== measureEditButtonClickConversion || $[33] !== migrateEPData || $[34] !== routePolicy || $[35] !== routeType || $[36] !== routesContext || $[37] !== spaceKey) {
        t14 = (e)=>{
            measureEditButtonClickConversion(e.isTrusted);
            (0, $74Lca.rememberScrolledPosition)(contentId);
            const details = (0, $dHSeC.getSpaTransitionDetails)(e, routesContext);
            const routePolicyPushInNewTab = routePolicy && !routePolicy.willPushInSelf(currentRouteName, contentId, routeType.name, contentId);
            if (!isBlogpost && Boolean(migrateEPData) && routePolicyPushInNewTab) {
                e.preventDefault();
                const navigateToEmbeddedEditor = ()=>{
                    routesContext.push((0, $1NBp8.EDIT_PAGE_EMBED).toUrl(linkParams));
                };
                const navigateToClassicEditor = ()=>{
                    routesContext.push(routeType.toUrl(linkParams));
                };
                migrateEPData(navigateToEmbeddedEditor, navigateToClassicEditor);
            }
            if (details?.href && !routePolicyPushInNewTab) {
                e.preventDefault();
                e.stopPropagation();
                if (!e.isTrusted) routesContext.preloadRoute(details.href);
                loadEditor({
                    contentId: contentId,
                    spaceKey: spaceKey,
                    redirectUrl: details.href,
                    contentType: contentType,
                    isFabricSupported: isFabricSupported,
                    isEmbeddedContent: isEmbeddedContent
                });
            }
        };
        $[24] = contentId;
        $[25] = contentType;
        $[26] = currentRouteName;
        $[27] = isBlogpost;
        $[28] = isEmbeddedContent;
        $[29] = isFabricSupported;
        $[30] = linkParams;
        $[31] = loadEditor;
        $[32] = measureEditButtonClickConversion;
        $[33] = migrateEPData;
        $[34] = routePolicy;
        $[35] = routeType;
        $[36] = routesContext;
        $[37] = spaceKey;
        $[38] = t14;
    } else t14 = $[38];
    routeType;
    const onClickEdit = t14;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const mode = match?.query?.mode;
    let t15;
    if ($[39] !== additionalAnalytics || $[40] !== contentId || $[41] !== contentType || $[42] !== isFabricSupported || $[43] !== isOnEditRoute || $[44] !== mode || $[45] !== searchSessionId) {
        t15 = (e_0, analyticsEvent)=>{
            analyticsEvent.update({
                data: {
                    action: "clicked",
                    actionSubject: "editButton",
                    attributes: {
                        componentVersion: "v2",
                        contentType: contentType,
                        contentId: contentId,
                        isFabricSupported: isFabricSupported,
                        navdexPointType: (0, $56QzY.END),
                        searchSessionId: searchSessionId,
                        ...additionalAnalytics,
                        mode: mode,
                        isOnEditRoute: isOnEditRoute
                    },
                    source: e_0.isTrusted ? "editContentButton" : "editShortcut"
                },
                type: "sendTrackEvent"
            }).fire();
        };
        $[39] = additionalAnalytics;
        $[40] = contentId;
        $[41] = contentType;
        $[42] = isFabricSupported;
        $[43] = isOnEditRoute;
        $[44] = mode;
        $[45] = searchSessionId;
        $[46] = t15;
    } else t15 = $[46];
    const fireClickAnalytics = t15;
    let t16;
    if ($[47] !== contentId || $[48] !== contentType || $[49] !== dataTestId || $[50] !== editShortcutStrings || $[51] !== enforceStorageLimit || $[52] !== fabricEditorEligibility || $[53] !== fireClickAnalytics || $[54] !== intl || $[55] !== isEmbeddedContent || $[56] !== isFabricEligibilityLoading || $[57] !== isFabricSupported || $[58] !== isPopupVisible || $[59] !== linkParams || $[60] !== localEditSource || $[61] !== onClickEdit || $[62] !== onRender || $[63] !== routeType || $[64] !== sendMetrics || $[65] !== shouldBlockCreate || $[66] !== spaceKey) {
        t16 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const [convertOnEditExpConfig] = (0, $6mKj3.UNSAFE_noExposureExp)("platform_editor_on_edit_convert");
            let t17;
            if ($[68] !== fabricEditorEligibility || $[69] !== isFabricSupported) {
                t17 = !isFabricSupported && typeof fabricEditorEligibility === "string" && [
                    "SUPPORTED",
                    "SUPPORTED_WITH_MIGRATION"
                ].includes(fabricEditorEligibility);
                $[68] = fabricEditorEligibility;
                $[69] = isFabricSupported;
                $[70] = t17;
            } else t17 = $[70];
            const showConvertPagePopup = t17;
            let t18;
            if ($[71] !== fireClickAnalytics || $[72] !== isEmbeddedContent || $[73] !== onClickEdit || $[74] !== sendMetrics || $[75] !== showConvertPagePopup) {
                t18 = (e_1, analyticsEvent_0)=>{
                    if (showConvertPagePopup && (0, $6mKj3.expValEquals)("platform_editor_on_edit_convert", "isEnabled", true)) {
                        e_1.preventDefault();
                        setIsPopupVisible($a4b894acf4b5251f$var$_temp);
                        fireClickAnalytics(e_1, analyticsEvent_0);
                    } else {
                        if (isEmbeddedContent) {
                            const observableObject = (0, $gzdsP.getIframeObservable_DO_NOT_USE)();
                            const uniqueKey = observableObject?.object?.uniqueKey;
                            sendMetrics({
                                timestamp: Date.now(),
                                ...uniqueKey && (0, $9wGTI.fg)("platform_deprecate_lp_cc_embed") ? {
                                    customData: {
                                        uniqueKey: uniqueKey
                                    }
                                } : {}
                            }, `${(0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX)}${(0, $4icDV.EMBEDDED_EDIT_CLICK)}`);
                        }
                        fireClickAnalytics(e_1, analyticsEvent_0);
                        onClickEdit(e_1);
                    }
                };
                $[71] = fireClickAnalytics;
                $[72] = isEmbeddedContent;
                $[73] = onClickEdit;
                $[74] = sendMetrics;
                $[75] = showConvertPagePopup;
                $[76] = t18;
            } else t18 = $[76];
            const handleButtonClick = t18;
            let t19;
            if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
                t19 = (0, $9wGTI.fg)("platform_tooltip_shortcuts_migration_1") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    id: "edit-button.tooltip",
                    defaultMessage: "Edit"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                    shortcut: (0, $gnkil.EDIT_SHORTCUT),
                    contentBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                        id: "edit-button.tooltip",
                        defaultMessage: "Edit"
                    }),
                    isTooltip: true
                });
                $[77] = t19;
            } else t19 = $[77];
            let t20;
            if ($[78] !== editShortcutStrings) {
                t20 = (0, $9wGTI.fg)("platform_tooltip_shortcuts_migration_1") ? editShortcutStrings : undefined;
                $[78] = editShortcutStrings;
                $[79] = t20;
            } else t20 = $[79];
            let t21;
            if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
                t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
                    label: "",
                    color: "var(--ds-icon-subtle, #505258)",
                    spacing: (0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "none" : "spacious"
                });
                $[80] = t21;
            } else t21 = $[80];
            let t22;
            if ($[81] !== enforceStorageLimit || $[82] !== handleButtonClick) {
                t22 = enforceStorageLimit(handleButtonClick);
                $[81] = enforceStorageLimit;
                $[82] = handleButtonClick;
                $[83] = t22;
            } else t22 = $[83];
            let t23;
            if ($[84] !== linkParams || $[85] !== routeType || $[86] !== shouldBlockCreate) {
                t23 = shouldBlockCreate ? undefined : routeType.toUrl(linkParams);
                $[84] = linkParams;
                $[85] = routeType;
                $[86] = shouldBlockCreate;
                $[87] = t23;
            } else t23 = $[87];
            let t24;
            if ($[88] !== intl) {
                t24 = intl.formatMessage($a4b894acf4b5251f$var$i18n.editLabel);
                $[88] = intl;
                $[89] = t24;
            } else t24 = $[89];
            let t25;
            if ($[90] !== intl) {
                t25 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                    color: "color.text.subtle",
                    align: "center",
                    weight: "medium",
                    "data-vc": "edit-button-text"
                }, intl.formatMessage($a4b894acf4b5251f$var$i18n.editText));
                $[90] = intl;
                $[91] = t25;
            } else t25 = $[91];
            let t26;
            if ($[92] !== dataTestId || $[93] !== t22 || $[94] !== t23 || $[95] !== t24 || $[96] !== t25) {
                t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a4b894acf4b5251f$var$StyledButton, {
                    appearance: "subtle",
                    iconBefore: t21,
                    ref: editButtonRef,
                    onClick: t22,
                    href: t23,
                    "data-test-id": dataTestId,
                    id: "editPageLink",
                    "aria-label": t24
                }, t25);
                $[92] = dataTestId;
                $[93] = t22;
                $[94] = t23;
                $[95] = t24;
                $[96] = t25;
                $[97] = t26;
            } else t26 = $[97];
            let t27;
            if ($[98] !== t20 || $[99] !== t26) {
                t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    tag: "span",
                    content: t19,
                    shortcut: t20
                }, t26);
                $[98] = t20;
                $[99] = t26;
                $[100] = t27;
            } else t27 = $[100];
            const button = t27;
            if (isFabricEligibilityLoading) {
                let t28;
                if ($[101] === Symbol.for("react.memo_cache_sentinel")) {
                    t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
                        interactionName: (0, $9wGTI.fg)("ufo-manual-experimental-holds-confluence") ? "edit-content-button-preloader" : undefined,
                        size: "small",
                        testId: "edit-content-button-preloader"
                    });
                    $[101] = t28;
                } else t28 = $[101];
                t16 = t28;
                break bb0;
            } else {
                let t28;
                if ($[102] === Symbol.for("react.memo_cache_sentinel")) {
                    t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
                        accelerator: (0, $gnkil.EDIT_SHORTCUT),
                        listener: clickEditPencilButton
                    });
                    $[102] = t28;
                } else t28 = $[102];
                let t29;
                if ($[103] !== onRender) {
                    t29 = onRender();
                    $[103] = onRender;
                    $[104] = t29;
                } else t29 = $[104];
                const t30 = showConvertPagePopup && convertOnEditExpConfig.get("isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
                    isOpen: isPopupVisible,
                    onClose: ()=>setIsPopupVisible(false),
                    placement: "bottom-start",
                    content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $emYzJ.EditPopupEligibleMigration), {
                            onClickEdit: onClickEdit,
                            contentId: contentId,
                            href: shouldBlockCreate ? undefined : routeType.toUrl(linkParams),
                            contentHash: "",
                            contentType: contentType,
                            spaceKey: spaceKey
                        }),
                    offset: [
                        -34,
                        8
                    ],
                    trigger: (t31)=>{
                        const { ref: ref } = t31;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                            ref: ref
                        }, button);
                    },
                    shouldRenderToParent: (0, $9wGTI.fg)("should-render-to-parent-should-be-trueenterprise-e")
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, button);
                let t32;
                if ($[105] === Symbol.for("react.memo_cache_sentinel")) {
                    t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
                        name: (0, $irVI7.VIEW_PAGE_EDIT_BUTTON_EXPERIENCE)
                    });
                    $[105] = t32;
                } else t32 = $[105];
                let t33;
                if ($[106] !== contentId || $[107] !== isEmbeddedContent || $[108] !== localEditSource || $[109] !== spaceKey || $[110] !== t29 || $[111] !== t30) {
                    t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $sD2Tz.EditContentButtonPreloader), {
                        key: contentId,
                        contentId: contentId,
                        spaceKey: spaceKey,
                        isEmbeddedEditor: isEmbeddedContent,
                        editSource: localEditSource
                    }, t28, t29, t30, t32);
                    $[106] = contentId;
                    $[107] = isEmbeddedContent;
                    $[108] = localEditSource;
                    $[109] = spaceKey;
                    $[110] = t29;
                    $[111] = t30;
                    $[112] = t33;
                } else t33 = $[112];
                t16 = t33;
                break bb0;
            }
        }
        $[47] = contentId;
        $[48] = contentType;
        $[49] = dataTestId;
        $[50] = editShortcutStrings;
        $[51] = enforceStorageLimit;
        $[52] = fabricEditorEligibility;
        $[53] = fireClickAnalytics;
        $[54] = intl;
        $[55] = isEmbeddedContent;
        $[56] = isFabricEligibilityLoading;
        $[57] = isFabricSupported;
        $[58] = isPopupVisible;
        $[59] = linkParams;
        $[60] = localEditSource;
        $[61] = onClickEdit;
        $[62] = onRender;
        $[63] = routeType;
        $[64] = sendMetrics;
        $[65] = shouldBlockCreate;
        $[66] = spaceKey;
        $[67] = t16;
    } else t16 = $[67];
    if (t16 !== Symbol.for("react.early_return_sentinel")) return t16;
});
const $a4b894acf4b5251f$export$812a4eda75b35614 = (0, $gmMgo.default)($a4b894acf4b5251f$var$EditContentButtonComponentInner);
$a4b894acf4b5251f$export$812a4eda75b35614.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onRender: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    isCompanyHubButton: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isEmbeddedContent: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isFabricSupported: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
function $a4b894acf4b5251f$var$_temp(prev) {
    return !prev;
}
module.exports["EditContentButtonComponent"] = $a4b894acf4b5251f$export$812a4eda75b35614;

});

parcelRegister("74Lca", function(module, exports) {

var $51ADl = parcelRequire("51ADl");


var $1dnxO = parcelRequire("1dnxO");


var $dpqzw = parcelRequire("dpqzw");


var $b1pBe = parcelRequire("b1pBe");

const $7936391e07f83542$export$69c870891d17d6d0 = (contentId)=>{
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    // root page element
    const page = isNav4Enabled ? document?.getElementById((0, $51ADl.NAV_4_MAIN_CONTENT_ID)) || document.documentElement : document.documentElement;
    // get fabric or classic renderer content id
    const pageContent = document.getElementById((0, $dpqzw.FABRIC_PAGE_CONTENT_ID));
    // if there's no page content, do nothing
    if (!pageContent) return;
    // if the user is already at the top of the page, then no need to scroll
    if (page.scrollTop / page.clientHeight < 0.25) return;
    // save closest scrolled element & contentId to localstorage
    (0, $b1pBe.getClosestScrolledElementIndex)(page, pageContent, contentId);
};
module.exports["rememberScrolledPosition"] = $7936391e07f83542$export$69c870891d17d6d0;

});

parcelRegister("51ADl", function(module, exports) {
const $06488191c40cb6cf$export$cd4d46bdb3670fbb = 'AkMainContent';
module.exports["NAV_4_MAIN_CONTENT_ID"] = $06488191c40cb6cf$export$cd4d46bdb3670fbb;

});

parcelRegister("b1pBe", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $dpqzw = parcelRequire("dpqzw");

const $f44449ceafa69a86$export$1df42b18d7384de5 = (page, pageContent, contentId)=>{
    if (!pageContent) return;
    // grab all of the direct children elements from the rendered content view
    const elementCollection = pageContent.querySelector((0, $dpqzw.RENDERED_CONTENT_SELECTOR))?.children || [];
    // set initial index to -1 in case no closest element is found
    let closestElementIndex = -1;
    // go through all direct children elements and see which is closest to the remembered scroll position
    if (elementCollection.length > 0) {
        const childrenElements = Array.from(elementCollection);
        // calculate scroll position based off of how far a user has scrolled the page minus the distance from the renderer content to the top of the page
        const pageScrollTop = page.scrollTop - pageContent.offsetTop;
        childrenElements.reduce((best, elem, index)=>{
            if (Math.abs(pageScrollTop - elem.offsetTop) < Math.abs(pageScrollTop - best.offsetTop)) {
                closestElementIndex = index;
                return elem;
            } else return best;
        });
    }
    // save the closest element's index to local storage
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LOCAL_STORAGE_CONTENT_VIEW_CLOSEST_ELEMENT_SCROLL_POSITION, {
        index: closestElementIndex,
        contentId: contentId
    });
};
module.exports["getClosestScrolledElementIndex"] = $f44449ceafa69a86$export$1df42b18d7384de5;

});

parcelRegister("emYzJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $ccHMk = parcelRequire("ccHMk");

var $7p4As = parcelRequire("7p4As");


var $fpGTa = parcelRequire("fpGTa");

var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $7Sm4c = parcelRequire("7Sm4c");


var $briGH = parcelRequire("briGH");


var $emb8c = parcelRequire("emb8c");

const $1c786d1286cf45c7$var$i18n = (0, $cgtv4.defineMessages)({
    elligibleMigrationModalTitle: {
        id: "fabric-page-optin-migration.elligible-migration-modal.title",
        defaultMessage: "Time to convert your page"
    },
    elligibleMigrationModalDescription: {
        id: "fabric-page-optin-migration.elligible-migration-modal.description",
        defaultMessage: "This page is compatible with the cloud editor. The legacy editor will be phased out soon, find out more in the <link>announcement</link>."
    },
    elligibleMigrationModalUpdateButton: {
        id: "fabric-page-optin-migration.elligible-migration-modal.update-button",
        defaultMessage: "Convert page"
    },
    elligibleMigrationModalCancelButton: {
        id: "fabric-page-optin-migration.elligible-migration-modal.cancel-button",
        defaultMessage: "Not now"
    },
    elligibleMigrationModalUnsupported: {
        id: "fabric-page-optin-migration.elligible-migration-modal.unsupported",
        defaultMessage: "This page cannot be converted"
    }
});
const $1c786d1286cf45c7$var$popupContainerStyle = (0, $ecnYn.xcss)({
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $1c786d1286cf45c7$var$topMarginStyle = (0, $ecnYn.xcss)({
    marginTop: 'space.200'
});
const $1c786d1286cf45c7$var$buttonContainerStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 'space.200'
});
const $1c786d1286cf45c7$var$widthStyle = (0, $ecnYn.xcss)({
    width: '297px'
});
const $1c786d1286cf45c7$export$4e1bf6f2717dc4c8 = ({ onClickEdit: onClickEdit, contentId: contentId, href: href, contentHash: contentHash, contentType: contentType, spaceKey: spaceKey })=>{
    const [popupMessage, setPopupMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState({
        ...$1c786d1286cf45c7$var$i18n.elligibleMigrationModalDescription
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [migratePages] = (0, $emb8c.useExperimentalMigratePagesMutation)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'eligibleMigrationModal'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onClickConvert = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(async (e)=>{
        e.preventDefault();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'eligibleMigrationModalConvertButton',
                source: 'editPopupEligibleMigration'
            }
        }).fire();
        const response = await migratePages({
            variables: {
                contentId: contentId,
                contentHash: contentHash
            }
        });
        const status = (0, $briGH.getStatusFromResponse)(response);
        if (status === '200' || status === '204') {
            const redirectRoute = contentType === 'page' ? (0, $1NBp8.EDIT_PAGE_V2).toUrl({
                contentType: 'pages',
                spaceKey: spaceKey,
                contentId: contentId
            }) : (0, $1NBp8.EDIT_BLOG_V2).toUrl({
                contentType: 'blog',
                spaceKey: spaceKey,
                contentId: contentId
            });
            // perform redirect
            push(redirectRoute);
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).PAGE_JUST_CONVERTED, contentId);
        } else {
            setPopupMessage($1c786d1286cf45c7$var$i18n.elligibleMigrationModalUnsupported);
            if (response && 'errors' in response && response.errors) (0, $7Sm4c.markErrorAsHandled)(response.errors);
        }
    }, [
        createAnalyticsEvent,
        migratePages,
        contentId,
        contentHash,
        contentType,
        spaceKey,
        push
    ]);
    if (!isLoggedIn || !href) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1c786d1286cf45c7$var$popupContainerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1c786d1286cf45c7$var$widthStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        tagName: "h3",
        ...$1c786d1286cf45c7$var$i18n.elligibleMigrationModalTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1c786d1286cf45c7$var$topMarginStyle,
        role: "status",
        "aria-live": "polite",
        "aria-atomic": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...popupMessage,
        tagName: "p",
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks),
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
                    href: "https://community.atlassian.com/forums/Confluence-articles/The-Legacy-Editor-is-being-deprecated-in-Confluence-Cloud-Here-s/ba-p/3046832",
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, chunks)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1c786d1286cf45c7$var$topMarginStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1c786d1286cf45c7$var$buttonContainerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        appearance: "subtle",
        href: href,
        onClick: onClickEdit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $1c786d1286cf45c7$var$i18n.elligibleMigrationModalCancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: onClickConvert
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $1c786d1286cf45c7$var$i18n.elligibleMigrationModalUpdateButton))))));
};
module.exports["EditPopupEligibleMigration"] = $1c786d1286cf45c7$export$4e1bf6f2717dc4c8;

});

parcelRegister("briGH", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $7W8i8 = parcelRequire("7W8i8");

const $8540b650e122e686$var$RETRY_STATUS_CODE = [
    409,
    412
];
const $8540b650e122e686$export$8e3b4758c0e0a83 = (response)=>response?.data?.experimentalMigratePages?.status;
const $8540b650e122e686$var$logger = (0, $7W8i8.getLogger)('PageMigration');
const $8540b650e122e686$export$9369b12211e1fce4 = (refetchContentHash, migratePages, retriesLeft = 3, interval = 1000, statusCodes = [])=>{
    return new Promise((resolve, reject)=>{
        // b/c contentHash is variable and could changed when user in preview
        // perform refetch to grab the latest contentHash (to avoid 412 and 409 error when performing migration)
        return refetchContentHash().then((contentHash)=>{
            migratePages(contentHash).then((response)=>{
                const status = $8540b650e122e686$export$8e3b4758c0e0a83(response);
                setTimeout(()=>{
                    if (retriesLeft === 1) {
                        const message = 'Number of retrying attempt reach maximum number of retries';
                        $8540b650e122e686$var$logger.debug`${message}`;
                        return reject(message, statusCodes);
                    }
                    // only retry when status code is 409, 412
                    if ($8540b650e122e686$var$RETRY_STATUS_CODE.indexOf(Number.parseInt(status)) !== -1) {
                        statusCodes.push(Number.parseInt(status));
                        $8540b650e122e686$export$9369b12211e1fce4(refetchContentHash, migratePages, retriesLeft - 1, interval, statusCodes).then(resolve, reject);
                    } else return resolve(response, statusCodes);
                }, interval);
            }).catch((error)=>{
                return reject(error, statusCodes);
            });
        });
    });
};
module.exports["getStatusFromResponse"] = $8540b650e122e686$export$8e3b4758c0e0a83;
module.exports["retry"] = $8540b650e122e686$export$9369b12211e1fce4;

});

parcelRegister("emb8c", function(module, exports) {

var $aBfpe = parcelRequire("aBfpe");


var $9o40q = parcelRequire("9o40q");


var $hBkCm = parcelRequire("hBkCm");

const $b8f7841fb375e78f$export$bff11ed54317b5ef = ({ onCompleted: onCompleted, onError: onError } = {})=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: ({ contentId: contentId, contentHash: contentHash })=>`/wiki/rest/api/content/${contentId}/convert?hash=${contentHash}`,
        method: 'PUT',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON,
            'X-Requested-With': 'XMLHttpRequest'
        },
        parseResult: (response)=>({
                experimentalMigratePages: {
                    status: String(response.status)
                }
            }),
        parseResponseOnSuccess: async (response)=>{
            return {
                status: response.status
            };
        },
        parseResponseOnError: async (error)=>{
            if ((0, $hBkCm.BadStatusError).isBadStatusError(error)) return {
                status: error.response.status
            };
            throw error;
        },
        onCompleted: onCompleted,
        onError: onError
    });
};
module.exports["useExperimentalMigratePagesMutation"] = $b8f7841fb375e78f$export$bff11ed54317b5ef;

});

parcelRegister("ca2z9", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $2HZwz = parcelRequire("2HZwz");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");

const $a70c768defde6626$var$UseFabricEligibilityMigrationQuery = (0, $2HZwz.default);
const $a70c768defde6626$export$848562a07f990254 = (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { contentId: contentId, isFabricSupported: isFabricSupported } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const shouldFetch = isFabricSupported === false;
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            fetchPolicy: (0, $6mKj3.expVal)("confluence_fabric_eligibility_query_cachefirst", "isEnabled", false) ? "cache-first" : "cache-and-network",
            variables: {
                contentId: contentId
            }
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($a70c768defde6626$var$UseFabricEligibilityMigrationQuery, t1);
    let t2;
    if ($[2] !== contentId || $[3] !== createAnalyticsEvent) {
        t2 = (t3)=>{
            const { reason: reason } = t3;
            createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    action: "failed",
                    actionSubject: "fabricEditorEligibilityQuery",
                    attributes: {
                        contentId: contentId,
                        reason: reason
                    },
                    source: "editContentButton"
                }
            }).fire();
        };
        $[2] = contentId;
        $[3] = createAnalyticsEvent;
        $[4] = t2;
    } else t2 = $[4];
    const fireErrorEvent = t2;
    let t3;
    let t4;
    if ($[5] !== error || $[6] !== fireErrorEvent) {
        t3 = ()=>{
            if (error) fireErrorEvent({
                reason: "APOLLO_ERROR"
            });
        };
        t4 = [
            error,
            fireErrorEvent
        ];
        $[5] = error;
        $[6] = fireErrorEvent;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    bb0: {
        if (!shouldFetch) {
            let t6;
            if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
                t6 = {
                    fabricEditorEligibility: null,
                    contentHash: null,
                    isFabricEligibilityLoading: false
                };
                $[9] = t6;
            } else t6 = $[9];
            t5 = t6;
            break bb0;
        }
        if (!data && shouldFetch) {
            let t6;
            if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
                t6 = {
                    isFabricEligibilityLoading: true,
                    fabricEditorEligibility: null,
                    contentHash: null
                };
                $[10] = t6;
            } else t6 = $[10];
            t5 = t6;
            break bb0;
        }
        if (!data && loading) {
            let t6;
            if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
                t6 = {
                    isFabricEligibilityLoading: true,
                    fabricEditorEligibility: null,
                    contentHash: null
                };
                $[11] = t6;
            } else t6 = $[11];
            t5 = t6;
            break bb0;
        }
        if (data) {
            const metadataFrontend = data?.content?.nodes?.[0]?.metadata?.frontend;
            const fabricEditorEligibility = metadataFrontend?.fabricEditorEligibility;
            const contentHash = metadataFrontend?.contentHash;
            let t6;
            if ($[12] !== contentHash || $[13] !== fabricEditorEligibility) {
                t6 = {
                    fabricEditorEligibility: fabricEditorEligibility,
                    contentHash: contentHash,
                    isFabricEligibilityLoading: false
                };
                $[12] = contentHash;
                $[13] = fabricEditorEligibility;
                $[14] = t6;
            } else t6 = $[14];
            t5 = t6;
            break bb0;
        }
        let t6;
        if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = {
                fabricEditorEligibility: null,
                contentHash: null,
                isFabricEligibilityLoading: false
            };
            $[15] = t6;
        } else t6 = $[15];
        t5 = t6;
    }
    return t5;
};
module.exports["useFabricEligibilityMigrationQuery"] = $a70c768defde6626$export$848562a07f990254;

});

parcelRegister("2HZwz", function(module, exports) {
/**
 * @generated SignedSource<<f41c893ddfe3d66df98f50dbc01536a5>>
 * @relayHash ec4bb4fc4b91bdd22636b8cd5a8459f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b983ca5b9bb7742a71d4d350f250a5524ffb46863ceb1b44624ac1b612ac288
const $41339af49efc6ee3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorEligibility"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "contentHash"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFabricEligibilityMigrationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFabricEligibilityMigrationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ec4bb4fc4b91bdd22636b8cd5a8459f5",
            "id": "1b983ca5b9bb7742a71d4d350f250a5524ffb46863ceb1b44624ac1b612ac288",
            "metadata": {},
            "name": "useFabricEligibilityMigrationQuery",
            "operationKind": "query",
            "text": "query useFabricEligibilityMigrationQuery($contentId:ID!){content(id:$contentId){nodes{id,metadata{frontend{fabricEditorEligibility,contentHash}}}}}"
        }
    };
}();
$41339af49efc6ee3$var$node.hash = "204d8fbd9ab341cec958fee25e721167";
var $41339af49efc6ee3$export$2e2bcd8739ae039 = $41339af49efc6ee3$var$node;
module.exports["default"] = $41339af49efc6ee3$export$2e2bcd8739ae039;

});

parcelRegister("7mHcA", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");


var $inPa6 = parcelRequire("inPa6");

let $6feb6b3d360f0331$var$onMigrationSuccess = ()=>{};
let $6feb6b3d360f0331$var$onMigrationFailure = ()=>{};
const $6feb6b3d360f0331$export$a48339a192545f1f = (contentId, skipOnLoadQuery)=>{
    const $ = (0, $frIzR.c)(29);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] !== contentId || $[1] !== createAnalyticsEvent) {
        t0 = (t1)=>{
            const { action: action, actionSubjectId: actionSubjectId, withMigration: withMigration, error: error } = t1;
            return createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    action: action,
                    actionSubject: "ncsMigrationQuery",
                    actionSubjectId: actionSubjectId,
                    source: "embeddedPageViewScreen",
                    object: {
                        id: contentId,
                        type: "page"
                    },
                    attributes: {
                        withMigration: withMigration,
                        error: error
                    }
                }
            }).fire();
        };
        $[0] = contentId;
        $[1] = createAnalyticsEvent;
        $[2] = t0;
    } else t0 = $[2];
    const trackMigrationEvent = t0;
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $eSUdr.default)`query useEmbeddedMigrationQueryEmbeddedWithMigrationQuery($contentId:ID!){content(id:$contentId){nodes{id type metadata{frontend{embeddedWithMigration}}}}}`;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== contentId) {
        t2 = {
            contentId: contentId
        };
        $[4] = contentId;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    let t4;
    if ($[6] !== trackMigrationEvent) {
        t3 = (data)=>{
            if (data?.content?.nodes?.[0]?.metadata?.frontend?.embeddedWithMigration ?? false) trackMigrationEvent({
                action: "completed",
                actionSubjectId: "ncsMigrationOnLoad",
                withMigration: true
            });
            else trackMigrationEvent({
                action: "completed",
                actionSubjectId: "ncsMigrationOnLoad",
                withMigration: false
            });
        };
        t4 = (err)=>{
            trackMigrationEvent({
                action: "failed",
                actionSubjectId: "ncsMigrationOnLoad",
                error: err.message
            });
        };
        $[6] = trackMigrationEvent;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    let t5;
    if ($[9] !== skipOnLoadQuery || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
        t5 = {
            variables: t2,
            fetchPolicy: "network-only",
            skip: skipOnLoadQuery,
            onCompleted: t3,
            onError: t4
        };
        $[9] = skipOnLoadQuery;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    const epMigrationOnLoad = (0, $j1Ss3.useQuery)(t1, t5);
    let t6;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $eSUdr.default)`query useEmbeddedMigrationQueryEmbeddedWithMigrationQuery($contentId:ID!){content(id:$contentId){nodes{id type metadata{frontend{embeddedWithMigration}}}}}`;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== contentId) {
        t7 = {
            contentId: contentId
        };
        $[15] = contentId;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== trackMigrationEvent) {
        t8 = (err_0)=>{
            trackMigrationEvent({
                action: "failed",
                actionSubjectId: "ncsMigrationOnEditClick",
                error: err_0?.message
            });
            $6feb6b3d360f0331$var$onMigrationFailure(err_0);
        };
        $[17] = trackMigrationEvent;
        $[18] = t8;
    } else t8 = $[18];
    const [migrateData, t9] = (0, $j1Ss3.useLazyQuery)(t6, {
        variables: t7,
        fetchPolicy: "network-only",
        onCompleted: (data_0)=>{
            if (data_0?.content?.nodes?.[0]?.metadata?.frontend?.embeddedWithMigration ?? false) {
                trackMigrationEvent({
                    action: "completed",
                    actionSubjectId: "ncsMigrationOnEditClick",
                    withMigration: true
                });
                $6feb6b3d360f0331$var$onMigrationSuccess(onClickData);
            } else {
                trackMigrationEvent({
                    action: "completed",
                    actionSubjectId: "ncsMigrationOnEditClick",
                    withMigration: false
                });
                $6feb6b3d360f0331$var$onMigrationFailure();
            }
        },
        onError: t8
    });
    const { data: t10, loading: onClickLoading, error: onClickError } = t9;
    const onClickData = t10;
    let t11;
    if ($[19] !== migrateData) {
        t11 = (t12, t13)=>{
            const onSuccess = t12 === undefined ? $6feb6b3d360f0331$var$_temp : t12;
            const onFailure = t13 === undefined ? $6feb6b3d360f0331$var$_temp2 : t13;
            $6feb6b3d360f0331$var$onMigrationSuccess = onSuccess;
            $6feb6b3d360f0331$var$onMigrationFailure = onFailure;
            migrateData();
        };
        $[19] = migrateData;
        $[20] = t11;
    } else t11 = $[20];
    const migrateEPData = t11;
    let t12;
    if ($[21] !== migrateEPData || $[22] !== onClickData || $[23] !== onClickError || $[24] !== onClickLoading) {
        t12 = {
            migrateEPData: migrateEPData,
            data: onClickData,
            loading: onClickLoading,
            error: onClickError
        };
        $[21] = migrateEPData;
        $[22] = onClickData;
        $[23] = onClickError;
        $[24] = onClickLoading;
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== epMigrationOnLoad || $[27] !== t12) {
        t13 = {
            epMigrationOnLoad: epMigrationOnLoad,
            epMigrationOnClick: t12
        };
        $[26] = epMigrationOnLoad;
        $[27] = t12;
        $[28] = t13;
    } else t13 = $[28];
    return t13;
};
function $6feb6b3d360f0331$var$_temp() {}
function $6feb6b3d360f0331$var$_temp2() {}
module.exports["useEmbeddedMigrationQuery"] = $6feb6b3d360f0331$export$a48339a192545f1f;

});

parcelRegister("8HdsQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h0mTL = parcelRequire("h0mTL");


var $jIlrR = parcelRequire("jIlrR");


var $lF24E = parcelRequire("lF24E");

const $262f69aacf5ded76$var$noop = ()=>{};
const $262f69aacf5ded76$export$e64f20017ef2874a = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, isCommentButtonSSRd: isCommentButtonSSRd = false })=>{
    const { data: data, error: error } = (0, $lF24E.usePreloadCommentButton)(contentId, isCommentButtonSSRd);
    const contentNode = data?.commentData?.content?.nodes?.[0];
    const isFabricSuported = contentNode?.metadata?.frontend?.fabricEditorSupported ?? false;
    const [showCommentButton, setShowCommentButton] = (0, $42omo.useState)(false);
    /* Scenario: A user has clicked on the button in SSR -> SPA transition.
     The mouse click event is captured and the loading of CommentButtonLazy is started.
     */ const handleCommentButtonClick = ()=>{
        setShowCommentButton(true);
    };
    /*Conditional Loading of CommentButtonLazy if FF is ON and showCommentButton true (user click)*/ /* in case of an error from CommentButtonQuery load CommentButtonLazy and allow CommentButton to make
          another network call to fetch data*/ const isDataLoaded = Boolean(data?.commentData && !error);
    if (showCommentButton || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h0mTL.CommentButtonLazy), {
        contentId: contentId,
        isDataLoaded: isDataLoaded,
        isFabricPage: isFabricSuported
    }));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jIlrR.CommentButtonPlaceholder), {
        isDisabled: !isDataLoaded && !isCommentButtonSSRd,
        handleCommentButtonClick: isDataLoaded || isCommentButtonSSRd ? handleCommentButtonClick : $262f69aacf5ded76$var$noop,
        contentId: contentId
    }));
});
module.exports["CommentButtonWrapper"] = $262f69aacf5ded76$export$e64f20017ef2874a;

});

parcelRegister("h0mTL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $jIlrR = parcelRequire("jIlrR");


const $3ed4db9782b8d46b$export$43a94cba75d164d3 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "pHrwQ",
    name: "CommentButtonLazy",
    loader: async ()=>(await (parcelRequire("6dJMq"))).CommentButton,
    loading: ({ isDataLoaded: isDataLoaded })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jIlrR.CommentButtonPlaceholder), {
            isDisabled: !isDataLoaded
        })
});
module.exports["CommentButtonLazy"] = $3ed4db9782b8d46b$export$43a94cba75d164d3;

});

parcelRegister("6dJMq", function(module, exports) {

let $487777f390ab2dde$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $487777f390ab2dde$var$load("8tLTz"),
    $487777f390ab2dde$var$load("i1fe2")
]).then(()=>parcelRequire('32Ecy'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("lF24E", function(module, exports) {

var $6nmm4 = parcelRequire("6nmm4");


var $jMyy4 = parcelRequire("jMyy4");

const $d0986d2d4a7f2d28$var$usePreloadCommentButtonQuery = (0, $6nmm4.default);
const $d0986d2d4a7f2d28$export$d1f3401b494de415 = (contentId, isCommentButtonSSRd)=>{
    const { data: commentData, error: commentError } = (0, $jMyy4.useQueryInterop)($d0986d2d4a7f2d28$var$usePreloadCommentButtonQuery, {
        fetchPolicy: isCommentButtonSSRd ? 'cache-first' : 'cache-and-network',
        variables: {
            pageId: contentId
        }
    });
    return {
        data: {
            commentData: commentData
        },
        error: commentError
    };
};
module.exports["usePreloadCommentButton"] = $d0986d2d4a7f2d28$export$d1f3401b494de415;

});


//# sourceMappingURL=ContentTypesHeader.40df55e8.js.map
